import { useEffect } from "react"

export const useStopBodyScroll = (dependency: boolean) => {
  useEffect(() => {
    const overflow = dependency ? "hidden" : "auto"
    const position = dependency ? "relative" : "initial"
    document.body.style.overflow = overflow
    document.body.style.position = position
  }, [dependency])
}
